import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}

const modulesFiles = require.context("./modules", true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1")
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const routes = [
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "蓝蜘蛛 404",
    },
    component: () => import("@/views/404/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "蓝蜘蛛 登录",
    },
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      title: "蓝蜘蛛 注册",
    },
    component: () => import("@/views/register/index.vue"),
  },
  // 通用电表大屏
  {
    path: "/mbigscreen/:id",
    name: "mbigscreen",
    meta: {
      showTab: false,
      name: "mbigscreen",
      title: "大屏",
    },
    component: (resolve) =>
      require(["@/views/meter/large_screen/index.vue"], resolve),
  },
  // 定制鼎威大屏
  {
    path: "/bigscreen/:id",
    name: "bigscreen",
    meta: {
      showTab: false,
      name: "bigscreen",
      title: "大屏",
    },
    component: (resolve) => require(["@/views/bigscreen/index.vue"], resolve),
  },
  // 定制费尼亚电表大屏
  {
    path: "/bghn_fny_meterbigscreen",
    name: "bghn_fny_meterbigscreen",
    meta: {
      showTab: false,
      name: "bghn_fny_meterbigscreen",
      title: "费尼亚大屏",
    },
    component: (resolve) =>
      require(["@/views/feiniyaMeterBigscreen/index.vue"], resolve),
  },

  modules.admin,
  modules.energy,
  modules.series,
  modules.meter,
  modules.weather,
  modules.switch,
  modules.system,
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
